module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M29.932 16.064l-9.248 9.672a2.065 2.065 0 0 0 0 2.836l2.716 2.844c.752.78 1.964.78 2.716 0L39.44 17.488a2.075 2.075 0 0 0 0-2.844L25.992.584a1.869 1.869 0 0 0-2.716 0L20.564 3.42a2.075 2.075 0 0 0 0 2.844l9.368 9.8zM.564 6.264l9.372 9.796-9.252 9.676a2.065 2.065 0 0 0 0 2.836L3.4 31.416c.752.78 1.964.78 2.716 0L19.44 17.488a2.075 2.075 0 0 0 0-2.844L5.992.584a1.869 1.869 0 0 0-2.716 0L.564 3.42a2.075 2.075 0 0 0 0 2.844z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-angle-quote-1.js
// module id = 1381
// module chunks = 14